import type { IconProps } from '../types/IconProps.ts';
export const LockKeyhole: IconProps = {
    name: 'LockKeyhole',
    children: [
        `<path d="M20 10H4c-.55 0-1 .49-1 1.1v9.8c0 .61.45 1.1 1 1.1h16c.55 0 1-.49 1-1.1v-9.8c0-.61-.45-1.1-1-1.1" />`,
        `<path d="M7 10V6.44C7 4 9.24 2 12 2s5 1.99 5 4.44V10" />`,
        `<circle cx="12" cy="16" r="1" />`,
    ]
};